export const BREADCRUMB_LIST = [
  { id: "1", title: "Pedidos", active: false },
  { id: "2", title: "Alta de Disponibilidad", active: true },
]

